
import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding: 2rem;
`;

const PageTitle = styled.h1`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const Monitoring: React.FC = () => {
  return (
    <PageContainer>
      <PageTitle>Logs & Monitoramento</PageTitle>
      <p>Aqui você poderá visualizar os logs de automação, status e falhas.</p>
    </PageContainer>
  );
};

export default Monitoring;
